//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { withdrawDetail, withdrawHandle} from "@/model/distribution/withDraw";
import Xinput from '@/components/common/x-input.vue'
import {bankCardReg,nameReg,IDcardReg} from '@/utils/regular.js'

  export default {
    data() {
      return {
        success:false,
        disabled:false,
        selectFlag:false,
        info:{
          withdraw_amount:'--', //提现金额
          // "real_name": "",
          // "id_card": "",
          // "bank_no": ""
        },
        placeholder:['请输入您的真实姓名','请输入您的身份证号','请输入您的银行卡号'],
        verify:[{valid:false},{valid:false},{valid:false}]
      }
    },
    components: {
      Xinput
    },
    created () {
      this.getInfo();
    },
    watch: {
    },
    computed: {
    },
    methods: {
      // 获取提现信息
      getInfo(){
        withdrawDetail().then(res =>{
          if(res.real_name && res.id_card && res.bank_no){
            this.disabled = true;
          }
          this.info = res;
        })
      },

      // 点击提现
      btnClick() {
        let data = Object.assign({},this.info);
        delete data.withdraw_amount;
        // 不为空判断
        let fill = Object.keys(data).every((key,index) =>{
          if(!data[key]){
            this.$toast(this.placeholder[index]);
            this.$set(this.verify,index,{valid:true})
          }
          return data[key]
        })
        if(!fill){
          return false
        }
        // 不符合规则判断
        if(!nameReg.test(data.real_name)){
          this.$toast("请输入正确的真实姓名");
          this.$set(this.verify,0,{valid:true})

          return false
        }
        if(!IDcardReg(data.id_card)){
          this.$toast("请输入正确的身份证号");
          this.$set(this.verify,1,{valid:true})
          return false
        }
        if(!bankCardReg.test(data.bank_no)){
          this.$toast("请输入正确的银行卡号");
          this.$set(this.verify,2,{valid:true})
          return false
        }
        if(!this.disabled && !this.selectFlag){
          this.$toast("请阅读并勾选协议");
          return false
        }
        this.extract(data)
      },
      // pdf
      pdf(){
        this.$router.push({
            path: "/pdf",
            query:{
                insurFlag:'distribution',
                pdfFlag:'withDrawal',
                flag : 'postdisable'

            }
        });
      },
      // 去提现
      extract(data){
        withdrawHandle(data).then(res =>{
          if(res == 0){
            // 提现成功
            this.success = true
          }
          else if(res == 1){
            this.$alert({
              msg:'您的账户疑似有违规行为，已被冻结，暂时不可提现。<br/>如有疑问，请致电客服17310389137申诉。',
              onConfirm:()=>{
                console.log("确定")
              }
            })
          }else if(res == 2){
            this.$toast('账户余额为0')
          }else{
            this.$toast(res)
          }
        }).catch(err => {
          this.$toast(err.message)
        })
      }
    },
  }
